<template>
    <div>
        <h3>크리에이터 응원 이벤트 이용자 조회</h3>
        <b-card header="검색 조건">
              <b-form @submit.prevent="submitSearch">
                <b-form-group label-cols="2" horizontal label-class="pull-right"
                      label="게임"
                      description="">
                  <b-select v-model="searchGameId" v-on:change="changeGame($event)" :options="searchGameList">
                    <template slot="first">
                      <option :value="null" disabled>게임을 선택하세요</option>
                    </template>
                  </b-select>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label-class="pull-right"
                            label="이벤트"
                            description="">
                  <b-select v-model="searchEventId" :options="gameEventMap.get(searchGameId)">
                    <template slot="first">
                      <option :value="null" disabled>이벤트를 선택하세요</option>
                    </template>
                  </b-select>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label-class="pull-right"
                            label="이용자 타입"
                            description="">
                    <b-select v-model="selectedUserType" v-on:change="changeUserType($event)" :options="userTypeSelectList">
                    </b-select>
                </b-form-group>
                <b-form-group label-cols="2" horizontal label-class="pull-right"
                            label="이용자"
                            description="">
                    <b-row>
                        <b-col>
                            <b-select v-model="selectedIdType" :options="idTypeSelectList">
                                <template slot="first">
                                <option :value="null" disabled>아이디 타입을 선택하세요</option>
                                </template>
                            </b-select>
                        </b-col>
                        <b-col>
                            <b-form-input v-model="searchText">
                            </b-form-input>
                            </b-col>
                            <b-col>
                            <b-button variant="primary" type="submit" :disabled="isSearching">
                               유저 검색 <span v-if="isSearching">중...</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form-group>
              </b-form>
        </b-card>
        <b-card header="검색 결과: 유저정보">
            <div v-if="!isSearching && userInfo == null" class="mb-2">
                검색결과가 없습니다.
            </div>
            <div v-else-if="userInfo != null">
                <b-row>
                    <b-col>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                게임
                            </div>
                          {{ selectedCreatorEvent.appName }}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                이벤트
                            </div>
                            {{ selectedCreatorEvent.name }}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                이용자타입
                            </div>
                            <div v-if="userInfo">
                                {{ convertUserTypeName(userInfo.userType) }}
                            </div>
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                accountID
                            </div>
                            <div v-if="userInfo">
                                {{ userInfo.idpUserId }}
                            </div>
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                Game player Id
                            </div>
                            <div v-if="userInfo">
                                {{ userInfo.playerId }}
                            </div>
                        </b-media>
                    </b-col>
                    <b-col v-if="userInfo.userType =='SUPPORTER'">
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                적립예정 포인트
                            </div>
                            {{commaPoint(userInfo.waitedAmount)}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                응원가능 포인트
                            </div>
                            {{commaPoint(userInfo.reservesAmount)}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                응원한 포인트
                            </div>
                            {{commaPoint(userInfo.donationAmount)}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                응원한 크리에이터
                            </div>
                            <div>
                                {{userInfo.creatorCount}}<br/>
                                <span v-for="(item, index) in donationCreatorList"  v-bind:key="item.id">
                                    <a :href="`${origin}/creatorPromotion/user/list?idpType=KAKAO&idpUserId=${item.idpUserId}`" target="_blank">{{item.channelName}}</a>
                                    <span v-if="index != donationCreatorList.length -1">,</span>
                                </span>
                            </div>
                        </b-media>
                    </b-col>
                    <b-col v-else>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                채널명
                            </div>
                            {{userInfo.channelName}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                응원링크
                            </div>
                            <a :href="`https://game.kakao.com/cr/${selectedCreatorEvent.codeName}/${userInfo.supportCode}`" target="_blank">https://game.kakao.com/cr/{{selectedCreatorEvent.codeName}}/{{userInfo.supportCode}}</a>
                        </b-media>                        
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                누적 응원 포인트
                            </div>
                            {{commaPoint(userInfo.donationAmount)}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                누적 응원수
                            </div>
                            {{commaNumber(userInfo.donationCount)}}
                        </b-media>
                        <b-media>
                            <div slot="aside" class="asideHeader">
                                서포터즈
                            </div>
                            {{commaNumber(userInfo.supporterCount)}}
                        </b-media>
                    </b-col>
                </b-row>
            </div>
        </b-card>
        <b-card header="검색 결과가 없습니다" v-if="userInfo == null">
        </b-card>
        <b-card header="검색 결과: 포인트내역(적립예정 포인트도 포함)" v-else-if="userInfo.userType=='SUPPORTER'">
            <b-navbar>
                <b-nav pills>
                    <b-nav-item v-on:click="enrolledSupporterPointTypeFilterHandling(item)" :data-status=item.value :active="item.active" v-for="(item, index) in supporterPointTypeList" :key="index"> {{item.text}}</b-nav-item>
                </b-nav>
               <b-navbar-nav class="ml-auto">
                    <b-form-group
                            label="검색"
                            label-for="enrolledCreator"
                            label-cols="3"
                            horizontal>
                        <b-form-input id="enrolledCreator" type="text" placeholder="크리에이터 account id" v-model="creatorIdpUserIdSearch"></b-form-input>
                    </b-form-group>
                </b-navbar-nav>                
            </b-navbar>
            <b-table hover striped bordered responsive="sm" :items="supporterPointHistory.filterList" :fields="supporterPointHistory.fields" :per-page="supporterPointHistory.perPage"  :current-page="supporterPointHistoryCurrentPage" :sort-desc="true"
                      :show-empty=true empty-text="리스트가 없습니다." id="point-table">
                <template slot="createdAt" slot-scope="data">
                    {{convertDate(data.item.paymentTime).format('MM/DD HH:mm')}}
                </template>
                <template slot="type" slot-scope="data">
                    <div v-if="data.item.type == 'PAYMENT' && data.item.status == 'CANCELED'">
                        <del>{{ convertSupporterPointTypeName(data.item.type, data.item.status) }}</del>
                    </div>
                    <div v-else>
                        {{ convertSupporterPointTypeName(data.item.type, data.item.status) }}
                    </div>
                </template>
                <template slot="info" slot-scope="data">
                    <div v-if="data.item.type === 'DONATION'">
                      <div v-if="data.item.status === 'CANCELED'">
                        <del><strong>{{ data.item.info.channelName }}</strong> 응원</del>
                      </div>
                      <div v-else>
                        <strong>{{ data.item.info.channelName }}</strong> 응원
                      </div>
                    </div>
                    <div v-else-if="data.item.type == 'PAYMENT' && data.item.status == 'CONFIRMED'">
                        게임내 결제
                    </div>
                    <div v-else-if="data.item.type == 'PAYMENT' && data.item.status == 'WAITED'">
                        게임내 결제
                    </div>
                    <div v-else-if="data.item.type == 'CANCEL_PAYMENT' && data.item.status == 'CONFIRMED'">
                        게임내 결제 취소
                    </div>
                    <div v-else-if="data.item.type == 'PAYMENT' && data.item.status == 'CANCELED'">
                        <del>게임내 결제 취소</del>
                    </div>
                    <div v-else-if="data.item.type == 'REFUND_DONATION'">
                        결제취소로 인한 응원포인트 반환
                    </div>
                    <div v-else-if="data.item.type == 'RESTRICTED_DONATION'">
                        {{data.item.info.reason}}
                    </div>
                </template>
                <template slot="creatorIdpUserId" slot-scope="data">
                    <div v-if="data.item.creatorIdpUserId != null">
                            {{ data.item.creatorIdpUserId }}
                    </div>
                </template>                
                <template slot="payment" slot-scope="data">
                    <div v-if="data.item.type == 'PAYMENT' && (data.item.status == 'CONFIRMED' || data.item.status == 'WAITED')">
                        {{ commaPoint(data.item.amount, "+") }}
                    </div>
                    <div v-if="data.item.type == 'REFUND_DONATION'">
                        {{ commaPoint(data.item.amount, "+") }}
                    </div>
                    <div v-else-if="data.item.type == 'PAYMENT' && data.item.status == 'CANCELED'">
                        <del>{{ commaPoint(data.item.amount, "+") }}</del>
                    </div>
                </template>
                <template slot="cancelPayment" slot-scope="data">
                    <div v-if="data.item.type === 'DONATION'">
                        {{ commaPoint(data.item.amount, "-") }}
                    </div>
                    <div v-if="data.item.type === 'RESTRICTED_DONATION'">
                        <del>{{ commaPoint(data.item.amount, "-") }}</del>
                    </div>
                    <div v-else-if="data.item.type === 'CANCEL_PAYMENT' && data.item.status === 'CONFIRMED'">
                        {{ commaPoint(data.item.amount, "-") }}
                    </div>
                </template>
                <template slot="managementName" slot-scope="data">
                    <div v-if="data.item.type === 'DONATION' && data.item.status === 'CANCELED'" style="color: grey">
                      응원취소완료
                    </div>
                    <div v-else-if="data.item.type === 'DONATION'">
                      <b-link @click="showCancelDonationModal(data.item.supportInfoId, data.item.creatorId, 'SUPPORTER')">
                        응원취소
                      </b-link>
                    </div>
                    <div v-else>
                      -
                    </div>
                </template>
            </b-table>
            <nav>
                <b-pagination aria-controls="point-table" :total-rows="supporterPointHistory.filterList.length" :per-page="supporterPointHistory.perPage" v-model="supporterPointHistoryCurrentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
        </b-card>
        <b-card header="검색 결과: 응원 포인트 내역" v-else-if="userInfo.userType=='CREATOR'">
            <b-navbar>
                <b-nav pills>
                    <b-nav-item v-on:click="enrolledCreatorPointTypeFilterHandling(item)" :data-status=item.value :active="item.active" v-for="(item, index) in creatorPointTypeList" :key="index"> {{item.text}}</b-nav-item>
                </b-nav>
                <b-navbar-nav class="ml-auto">
                    <b-form-group
                            label="검색"
                            label-for="enrolledCreator"
                            label-cols="3"
                            horizontal>
                        <b-form-input id="enrolledCreator" type="text" autocomplete="enrolledCreator" placeholder="서포터 account id" v-model="supporterIdpUserIdSearch"></b-form-input>
                    </b-form-group>
                </b-navbar-nav>
            </b-navbar>
            <b-table hover striped bordered responsive="sm" :items="creatorPointHistory.list" :fields="creatorPointHistory.fields" :per-page="creatorPointHistory.perPage" :sort-desc="true"
                      :show-empty=true empty-text="리스트가 없습니다." id="point-table">
                <template slot="createdAt" slot-scope="data">
                    {{convertDate(data.item.createdAt).format('MM/DD HH:mm')}}
                </template>
                <template slot="type" slot-scope="data">
                    {{ convertCreatorPointTypeName(data.item.type, data.item.status) }}
                </template>
                <template slot="profileName" slot-scope="data" v-if="data.item.info !== null">
                    {{ data.item.info.profileName }}
                </template>
                <template slot="info" slot-scope="data">
                    <div v-if="data.item.type ==='DONATION' || data.item.type === 'RESTRICTED_DONATION'">
                        <div style="color: blue;" v-if="data.item.info !== null">
                            {{ data.item.info.message }}
                        </div>
                    </div>
                    <div v-else>
                        서포터의 게임내 결제 취소
                    </div>
                </template>
                <template slot="supporterId" slot-scope="data">
                    {{ data.item.supporter.cpAccount.idpUserId }}
                </template>
                <template slot="donation" slot-scope="data">
                    <div v-if="data.item.type === 'DONATION'">
                        {{ commaPoint(data.item.amount, "+") }}
                    </div>
                </template>
                <template slot="refundDonation" slot-scope="data">
                    <div v-if="(data.item.type === 'REFUND_DONATION' && data.item.status === 'CONFIRMED')
                        || (data.item.type === 'RESTRICTED_DONATION' && data.item.status === 'CONFIRMED')">
                        {{ commaPoint(data.item.amount, "-") }}
                    </div>
                </template>
                <template slot="managementName" slot-scope="data">
                  <div v-if="data.item.type === 'DONATION' && data.item.status !== 'CANCELED'">
                    <b-link @click="showCancelDonationModal(data.item.id, data.item.creator.id, 'CREATOR')">
                      응원취소
                    </b-link>
                  </div>
                  <div v-else-if="data.item.type === 'RESTRICTED_DONATION' && data.item.status === 'CONFIRMED'">
                    <b-link @click="showCompleteCancelDonationModal(data.item.info.reason)">
                      응원취소완료
                    </b-link>
                  </div>
                  <div v-else>
                    -
                  </div>
                </template>
            </b-table>
            <nav>
                <b-pagination aria-controls="point-table" :total-rows="creatorPointHistory.totalElements" :per-page="creatorPointHistory.perPage" v-model="creatorPointHistoryCurrentPage" first-text="First" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
        </b-card>
        <b-modal v-model="cancelSupportModal.isShow" ok-title="응원취소" cancel-title="닫기" centered id="cancel-modal"  ref="btnShow" @ok="handleCancelDonationOk">
          <div style="text-align: center; font-size: 20px;">
            <strong>{{cancelSupportModal.title}}</strong>
          </div>
          <br/>
          <br/>
          <b-form-group label="사유" horizontal>
            <b-form-textarea
                id="textarea"
                v-model="cancelSupportModal.description"
                placeholder="취소사유를 입력해주세요."
                rows="3"
                maxlength="30"
                :state="cancelSupportModal.description.length <= 30"
                max-rows="6" required>
            </b-form-textarea>
            <div style="text-align: right;">
              {{cancelSupportModal.description.length}}/30
            </div>
          </b-form-group>
          <div>
            <li>{{cancelSupportModal.content}}</li>
          </div>
        </b-modal>
        <b-modal  id="cancel-second-modal" ok-only>
          <p class="my-2">응원이 취소 되었습니다.</p>
        </b-modal>
        <b-modal v-model="completeCancelSupportModal.isShow" ok-title="닫기" ok-only centered>
          <div style="text-align: center; font-size: 20px;">
            <strong>응원취소완료</strong>
          </div>
          <br/>
          <br/>
          <b-form-group label="사유" horizontal>
            {{completeCancelSupportModal.description}}
          </b-form-group>
        </b-modal>
      </div>
</template>
<script>

    import creatorPromotionApi from '@/common/creatorPromotion/api/creatorPromotionApi'
    import { debounce } from 'lodash'
    import moment from 'moment'

    export default {
        name: "UserList",
        data() {
            return {
                origin: '',
                searchText: "",
                isSearching: false,
                userInfo: null,
                searchGameId: null,
                searchEventId: null,
                selectedEventId: null,
                gameEventMap: new Map(),
                gameIdSet: new Set(),
                searchGameList: [],
                eventList: [],
                selectedCreatorEvent: {},
                donationCreatorList: [],
                selectedUserType: "CREATOR",
                userTypeSelectList: [
                    {value: "CREATOR", text: "크리에이터"},
                    {value: "SUPPORTER", text: "서포터"},
                ],
                selectedIdType: null,
                idTypeSelectList: [
                    {value: "KAKAO", text: "Account id"},
                    {value: "ZINNY", text: "Game player id"},
                    {value: "CHANNEL", text: "채널 명"}
                ],
                selectedSupporterPointType: {value: { type: ['PAYMENT', 'CANCEL_PAYMENT', 'DONATION', 'REFUND_DONATION'], status: ['CONFIRMED', 'PARTIAL_CANCELED', 'CANCELED', 'WAITED'] },text: "전체",active: true},
                supporterPointTypeList: [
                    {value: { type: ['PAYMENT', 'CANCEL_PAYMENT', 'DONATION', 'RESTRICTED_DONATION', 'REFUND_DONATION'], status: ['CONFIRMED', 'PARTIAL_CANCELED', 'CANCELED', 'WAITED'] },text: "전체",active: true},
                    {value: { type: ['DONATION'], status: ['CONFIRMED', 'PARTIAL_CANCELED', 'CANCELED'] }, text: "응원",active: false},
                    {value: { type: ['PAYMENT'], status: ['CONFIRMED'] }, text: "적립",active: false},
                    {value: { type: ['CANCEL_PAYMENT'], status: ['CONFIRMED'] }, text: "적립 취소",active: false},
                    {value: { type: ['PAYMENT'], status: ['WAITED', 'CANCELED'] }, text: "적립 에정",active: false},
                    {value: { type: ['REFUND_DONATION'], status: ['CONFIRMED'] }, text: "응원 취소",active: false},
                ],
                supporterPointHistoryCurrentPage: 0,
                supporterPointHistory : {
                    list: [],
                    filterList: [],
                    totalPages: 1,
                    perPage : 10,
                    fields: [
                        {key: 'createdAt', label: '날짜', class: 'align-middle text-center'},
                        {key: 'type', label: '구분', class: 'align-middle text-center'},
                        {key: 'info', label: '항목', class: 'align-middle text-center'},
                        {key: 'creatorIdpUserId', label: '크리에이터 id', class: 'align-middle text-center'},
                        {key: 'payment', label: '포인트 적립', class: 'align-middle text-center', tdClass: 'plueClass'},
                        {key: 'cancelPayment', label: '포인트 차감', class: 'align-middle text-center', tdClass: 'minusClass'},
                        {key: 'managementName', label: '관리', class: 'align-middle text-center'}
                    ]
                },
                selectedCreatorPointType: {value: { type: ["ALL"] },text: "전체",active: true},
                creatorPointTypeList: [
                    {value: { type: "ALL" },text: "전체",active: true},
                    {value: { type: "DONATION" }, text: "적립",active: false},
                    {value: { type: "REFUND_DONATION"}, text: "적립 취소",active: false},
                    {value: { type: "RESTRICTED_DONATION" }, text: "응원 취소",active: false},
                ],
                creatorPointHistoryCurrentPage: 1,
                creatorPointHistory : {
                    list: [],
                    totalPages: 0,
                    totalElements: 0,
                    perPage : 10,
                    fields: [
                        {key: 'createdAt', label: '날짜', class: 'align-middle text-center'},
                        {key: 'type', label: '구분', class: 'align-middle text-center'},
                        {key: 'profileName', label: '서포터명', class: 'align-middle text-center'},
                        {key: 'info', label: '서포터요청사항', class: 'align-middle text-center'},
                        {key: 'supporterId', label: '서포터(account id)', class: 'align-middle text-center'},
                        {key: 'donation', label: '포인트 적립', class: 'align-middle text-center', tdClass: 'plueClass'},
                        {key: 'refundDonation', label: '포인트 차감', class: 'align-middle text-center', tdClass: 'minusClass'},
                        {key: 'managementName', label: '관리', class: 'align-middle text-center'}
                    ]
                },
                supporterIdpUserIdSearch: '',
                creatorIdpUserIdSearch: '',
                cancelSupportModal: {
                    isShow: false,
                    creatorId: '',
                    type: '',
                    id: '',
                    title: '',
                    description: ''
                },
                completeCancelSupportModal: {
                  isShow: false,
                  description: ''
                },
            }
        },
        methods: {
            async submitSearch() {
                if (!this.searchGameId) {
                  alert("게임을 선택하세요");
                  return;
                } else if (!this.searchEventId) {
                  alert("이벤트를 선택하세요");
                  return;
                } else if (!this.selectedUserType) {
                    alert("이용자 타입을 선택하세요");
                    return;
                } else if (!this.selectedIdType) {
                    alert("아이디 타입을 선택하세요");
                    return;
                } else if (this.searchText === "") {
                    alert("이용자 정보를 입력하세요");
                    return;
                }
                this.isSearching = true;
                this.userInfo = null;
                this.initSupporterPointType();
                this.initCreatorPointType();
                this.supporterPointHistoryCurrentPage = 0;
                this.creatorPointHistoryCurrentPage = 1;
                this.selectedEventId = this.searchEventId;


                this.selectedCreatorEvent = this.eventList.find((e)=> e.id == this.selectedEventId);

                await this.reqUserDetails(this.selectedUserType, this.selectedIdType, this.searchText);

            },
            initSupporterPointType() {
                const clickedIndex = 0;
                for (let item of this.supporterPointTypeList) {
                    item.active = false
                }
                this.supporterPointTypeList[clickedIndex].active = true
                this.selectedSupporterPointType = this.supporterPointTypeList[clickedIndex]
            },
            initCreatorPointType() {
                const clickedIndex = 0;
                for (let item of this.creatorPointTypeList) {
                    item.active = false
                }
                this.creatorPointTypeList[clickedIndex].active = true
                this.selectedCreatorPointType = this.creatorPointTypeList[clickedIndex]
            },
            enrolledSupporterPointTypeFilterHandling (clickedItem) {
                const clickedIndex = this.supporterPointTypeList.indexOf(clickedItem)
                for (let item of this.supporterPointTypeList) {
                    item.active = false
                }
                this.supporterPointTypeList[clickedIndex].active = true
                this.selectedSupporterPointType = this.supporterPointTypeList[clickedIndex]

                this.filterSupporterHistory(null);
            },
            supporterPointListSort() {
              this.supporterPointHistory.filterList.sort((a, b) => {
                return b.paymentTime.localeCompare(a.paymentTime);
              });
            },
            enrolledCreatorPointTypeFilterHandling (clickedItem) {
                const clickedIndex = this.creatorPointTypeList.indexOf(clickedItem)
                for (let item of this.creatorPointTypeList) {
                    item.active = false
                }
                this.creatorPointTypeList[clickedIndex].active = true
                this.selectedCreatorPointType = this.creatorPointTypeList[clickedIndex]

                this.reloadCreatorPointHistory();
                
            },
            reloadCreatorPointHistory() {
              if(this.creatorPointHistoryCurrentPage === 1) {
                this.reqCreatorPointHistory(this.userInfo.id, this.creatorPointHistory.perPage, this.creatorPointHistoryCurrentPage -1, this.selectedCreatorPointType.value, this.supporterIdpUserIdSearch);
              } else {
                this.creatorPointHistoryCurrentPage = 1;
              }
            },
            convertUserTypeName(type) {
                if(type === "SUPPORTER") {
                    return "서포터";
                } else if(type === "CREATOR") {
                    return "크리에이터";
                }
                return "";
            },
            convertSupporterPointTypeName(type, status) {
                if(type === "DONATION") {
                    return "응원";
                } else if(type === "PAYMENT" && status === 'CONFIRMED') {
                    return "적립"
                } else if(type === "CANCEL_PAYMENT" && status === 'CONFIRMED') {
                    return "적립 취소"
                } else if(type === "PAYMENT" && status === 'WAITED') {
                    return "적립 예정"
                } else if(type === "PAYMENT" && status === 'CANCELED') {
                    return "적립 예정 취소"
                } else if(type === "RESTRICTED_DONATION" || type === 'REFUND_DONATION') {
                    return "응원 취소"
                }

                return "";
            },
            convertCreatorPointTypeName(type, status) {
                if(type === "DONATION") {
                    return "적립";
                } else if(type === "REFUND_DONATION" && status === 'CONFIRMED') {
                    return "적립취소"
                } else if(type === 'RESTRICTED_DONATION' && status === 'CONFIRMED') {
                    return "응원취소";
                }
                return "";
            },
            async reqCreatorEventList() {
                const response = await creatorPromotionApi.getEventList();
                if(response.status === 200 && response.data.apiResultCode === 200) {
                
                    this.eventList = response.data.data;
                    this.eventList.forEach((e) => {
                      this.addGame(e);
                      this.addGameEvent(e);
                    });

                    const paramIdpUserId = this.$route.query.idpUserId;
                    const paramIdpType = this.$route.query.idpType;
                    const paramGameId = this.$route.query.gameId;
                    const paramEventId = this.$route.query.eventId;
                    if(paramIdpUserId !== undefined && paramIdpType !== undefined && paramGameId !== undefined && paramEventId !== undefined) {
                        this.selectedIdType = paramIdpType;
                        this.searchText = paramIdpUserId;
                        this.searchGameId = paramGameId;
                        this.searchEventId = paramEventId;

                        await this.submitSearch();
                    }
                }
            },
            addGame(e) {
              if(!this.gameIdSet.has(e.appId)) {
                  this.searchGameList.push({
                    'text': e.appName,
                    'value': e.appId,
                  });
                  this.gameIdSet.add(e.appId);
              }
            },
            addGameEvent(e) {
              if(this.gameEventMap.has(e.appId)) {
                this.gameEventMap.get(e.appId).push({
                  'text': e.name,
                  'value': e.id,
                });
              } else {
                this.gameEventMap.set(e.appId, [{
                  'text': e.name,
                  'value': e.id,
                }]);
              }
            },
            async reqSupporterPointHistory(idpUserId) {

              this.initPointHistory(this.supporterPointHistory);

              for(let i = 0;  i <= 100; i++) {

                if(this.supporterPointHistory.totalPages <= i)
                  break;

                const response = await creatorPromotionApi.getSupporterPointHistoryForPayment(this.selectedEventId, idpUserId, ['PAYMENT', 'CANCEL_PAYMENT'], ['CONFIRMED', 'WAITED', 'CANCELED'], 100, i);
                if(response.status === 200 && response.data.apiResultCode === 200) {
                  this.supporterPointHistory.list = this.supporterPointHistory.list.concat(response.data.data.content);
                  this.supporterPointHistory.totalPages = response.data.data.totalPages;
                }
              }
              this.supporterPointHistory.totalPages = 1;
              for(let i = 0;  i <= 100; i++) {

                if(this.supporterPointHistory.totalPages <= i)
                  break;

                const response = await creatorPromotionApi.getSupporterPointHistoryForSupport(this.selectedEventId, idpUserId, ['DONATION', 'REFUND_DONATION'], ['CONFIRMED', 'PARTIAL_CANCELED', 'CANCELED'], 100, i);
                if(response.status === 200 && response.data.apiResultCode === 200) {
                  this.supporterPointHistory.list = this.supporterPointHistory.list.concat(response.data.data.content);
                  this.supporterPointHistory.totalPages = response.data.data.totalPages;
                }
              }

              this.supporterPointHistory.filterList = this.supporterPointHistory.list;
              this.supporterPointListSort();
            },
            initPointHistory(pointHistory) {
                pointHistory.list = [];
                pointHistory.filterList = [];
                pointHistory.totalPages = 1;
            },
            async reqCreatorPointHistory(creatorId, size, page, pointHistoryType, idpUserId) {
                const response = await creatorPromotionApi.getCreatorPointHistory(this.selectedEventId, creatorId, pointHistoryType.type, size, page, idpUserId);
                if(response.status === 200 && response.data.apiResultCode === 200) {
                    const pointHistoryList = response.data.data;
                    this.creatorPointHistory.list = pointHistoryList.content;
                    this.creatorPointHistory.totalPages = pointHistoryList.totalPages;
                    this.creatorPointHistory.totalElements = pointHistoryList.totalElements;

                    return;
                }

                this.initPointHistory(this.creatorPointHistory);
            },
            async reqDonationCreatorList(supporterId) {
                const response = await creatorPromotionApi.getDonationCreatorListBySupport(this.selectedEventId, supporterId);
                if(response.status === 200 && response.data.apiResultCode === 200) {
                    this.donationCreatorList = response.data.data;
                }

            },
            async reqUserDetails(userType, idType, search) {
                const response = await creatorPromotionApi.getUserInfo(this.selectedEventId, userType, idType, search);
                this.isSearching = false;

                if(response.status === 200 && response.data.apiResultCode === 200) {

                    this.userInfo = response.data.data;
                    if(userType === "SUPPORTER") {
                        await this.reqDonationCreatorList(this.userInfo.id);
                        await this.reqSupporterPointHistory(this.userInfo.idpUserId);
                    } else {
                        await this.reqCreatorPointHistory(this.userInfo.id, this.creatorPointHistory.perPage, 0, this.selectedCreatorPointType.value, this.supporterIdpUserIdSearch);
                    }

                    return;
                }

                this.userInfo = null;
            },
            async requestToCancelDonationByCreator(param) {
              const requestBody = {
                'eventId': this.selectedEventId,
                'reason': param.description,
                'supportInfoId': param.id,
              }

              const response = await creatorPromotionApi.cancelDonation(param.creatorId, requestBody);
              if(response.status === 200 && response.data.apiResultCode === 200) {

                const userResponse = await creatorPromotionApi.getUserInfo(this.selectedEventId, this.userInfo.userType, "KAKAO", this.userInfo.idpUserId);
                if(userResponse.status === 200 && userResponse.data.apiResultCode === 200) {
                  this.userInfo = userResponse.data.data;
                }

                if(param.type === 'SUPPORTER') {
                  await this.reqSupporterPointHistory(this.userInfo.idpUserId);
                } else {
                  this.reloadCreatorPointHistory();
                }
                return true;
              }

              return false;
            },
            async handleCancelDonationOk(bvModalEvent) {
              bvModalEvent.preventDefault()

              if(this.cancelSupportModal.description.length <= 0 || this.cancelSupportModal.description.length > 30)
                return;

                let response = await this.requestToCancelDonationByCreator(this.cancelSupportModal);
                if(response === true) {

                    this.$root.$emit('bv::hide::modal', 'cancel-modal', '#btnShow');
                    this.$root.$emit("bv::show::modal", "cancel-second-modal");
                }
            },
            showCancelDonationModal(supportInfoId, creatorId, type) {
                this.cancelSupportModal.id = supportInfoId;
                this.cancelSupportModal.creatorId = creatorId;
                this.cancelSupportModal.isShow = true;
                this.cancelSupportModal.type = type;
                this.cancelSupportModal.content = '응원취소시 해당 포인트는 크리에이터의 응원포인트에서 차감됩니다. (크리에이터의 응원포인트 내역에서는 ‘이용제재에 따른 응원 취소’로 확인할 수 있습니다.)';
                this.cancelSupportModal.title = '응원을 취소처리하시겠습니까?';
                this.cancelSupportModal.description = '';
            },
            showCompleteCancelDonationModal(description) {
                this.completeCancelSupportModal.isShow = true;
                this.completeCancelSupportModal.description = description;
            },
            convertDate(time) {
                return moment(time)
            },
            commaPoint(val, sign) {
                if(val == null)
                    return '0p'
                if(sign == null)
                    return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'p';

                return sign + String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 'p';
            },
            commaNumber(val) {
              if(val == null)
                return '0'
              return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
            changeUserType(userType) {
                if(userType === "CREATOR") {
                    if(this.idTypeSelectList.length === 2) {
                        this.idTypeSelectList.push({value: "CHANNEL", text: "채널 명"})
                    }
                } else {
                    if(this.idTypeSelectList.length === 3) {
                        this.selectedIdType = null;
                        this.idTypeSelectList.pop()
                    }
                }
            },
            changeGame(id) {
              this.searchGameId = id;
              this.searchEventId = null;
            },
            filterSupporterHistory(creatorIdpUserId) {
              this.supporterPointHistoryCurrentPage = 0;
              if(creatorIdpUserId !== null && creatorIdpUserId !== "") {
                this.supporterPointHistory.filterList = this.supporterPointHistory.list.filter((value) =>
                    value.creatorIdpUserId === creatorIdpUserId &&
                    this.selectedSupporterPointType.value.type.includes(value.type) && this.selectedSupporterPointType.value.status.includes(value.status)
                );
              } else {
                this.supporterPointHistory.filterList = this.supporterPointHistory.list.filter((value) =>
                    this.selectedSupporterPointType.value.type.includes(value.type) && this.selectedSupporterPointType.value.status.includes(value.status)
                );
              }

              this.supporterPointListSort();
            }
        },
        async mounted() {
            this.origin = window.location.origin;
            await this.reqCreatorEventList();

        },
        watch: {
            creatorPointHistoryCurrentPage: function (pageNum) {
                if(this.userInfo == null)
                    return;

                this.reqCreatorPointHistory(this.userInfo.id, this.creatorPointHistory.perPage, pageNum-1, this.selectedCreatorPointType.value, this.supporterIdpUserIdSearch);
            },
            supporterIdpUserIdSearch: debounce(function(suppoterIdpUserId) {
                this.reqCreatorPointHistory(this.userInfo.id, this.creatorPointHistory.perPage, 0, this.selectedCreatorPointType.value, suppoterIdpUserId);
            }, 700),
            creatorIdpUserIdSearch: debounce(function(creatorIdpUserId) {
              this.filterSupporterHistory(creatorIdpUserId);
            }, 700),
        }
    }
</script>
<style>
    .asideHeader {
        width: 200px;
        text-align: end;
        padding-right:10px;
        background-color: #f0f3f5;
    }
    .plueClass {
        color: red;
        font-weight: bold;
    }
    .minusClass {
        font-weight: bold;
    }
</style>